// @flow
declare var __CAPACITOR__: boolean;
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { motion } from 'framer-motion';
// $FlowFixMe
import React, { useState, useEffect } from 'react';
import type { ChildrenArray, Element } from 'react';
import CapacitorRipple from '../capacitor/Ripple';
import IconLabel from './IconLabel';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import styles from './ContextMenu.css';
import { commonMessages } from '../messages/Common';

type OwnProps = {
  'children'?: ChildrenArray<Element<any>>,
  'data-test'?: string,
  'sideOffset'?: number,
  'side'?: 'top' | 'bottom' | 'left' | 'right',
  'align'?: 'start' | 'center' | 'end',
};

type Props = OwnProps & { intl: IntlShape };

const ContextMenu = ({ children, 'data-test': dataTest, intl, sideOffset, side, align }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleScroll = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const scrollingElement = __CAPACITOR__ ? window : document.querySelector('.content');
    if (scrollingElement) {
      scrollingElement.addEventListener('scroll', handleScroll);
      return () => {
        scrollingElement.removeEventListener('scroll', handleScroll);
      };
    }
    return () => {};
  }, []);

  return (
    <DropdownMenu.Root modal={false} onOpenChange={setIsOpen} open={isOpen}>
      <DropdownMenu.Trigger className={styles.button} data-test={dataTest}>
        <CapacitorRipple version="center" />
        <IconLabel size="default" name="more-vertical" />
        <span className="sr-only">
          {isOpen
            ? intl.formatMessage(commonMessages.closeMenu)
            : intl.formatMessage(commonMessages.openMenu)}
        </span>
      </DropdownMenu.Trigger>
      {isOpen && (
        <DropdownMenu.Portal container={document.getElementById('radix-portal')}>
          <DropdownMenu.Content
            asChild
            side={side || 'top'}
            align={align || 'end'}
            sideOffset={sideOffset || 0}
            forceMount
            avoidCollisions={false}
          >
            <motion.div
              key="dropdown"
              className={styles.menuItems}
              initial={{ opacity: 0, y: 5 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.15 }}
            >
              {children}
            </motion.div>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      )}
    </DropdownMenu.Root>
  );
};

export default injectIntl(ContextMenu);
